import { db } from "../../firebase";

export const Activity = db.collection("activities");
export const Users = db.collection("users");
